import { BankType, DebtManager } from '../generated/graphql';
import { getEntityLabel } from './financialEntitiesList';

export const getBankLabel = (bank: BankType | DebtManager, brand?: string | null) => getEntityLabel(bank, brand);
